import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { getCheckoutState } from "../../utils/reduxSelectors";
import {
  EVENT_PROPERTIES_VALUES,
  EVENT_PROPERTIES_NAMES,
} from "../../types/Amplitude";
import { checkout } from "../../actions/ShopActions";

// Components
import Button from "../Atoms/Button";
import { TrackingContext } from "./TrackingWrapper";

// Constants
const DEFAULT_BUTTON_PROPS = {
  size: "stretch",
};

const getLineItemDetails = (lineItems) => {
  return lineItems.map((item) => ({
    [EVENT_PROPERTIES_NAMES.Current_Quantity]: item.quantity,
    [EVENT_PROPERTIES_NAMES.Price]: parseFloat(item.variant.price),
    [EVENT_PROPERTIES_NAMES.Product]: item.title,
    [EVENT_PROPERTIES_NAMES.Product_Variant]: item.variant.name || null,
  }));
};

const getTotalQuantity = (lineItems) => {
  return lineItems.reduce((total, item) => {
    total += item.quantity;

    return total;
  }, 0);
};

const openCheckout =
  ({
    subtotalPrice,
    lineItems,
    trackCheckout,
    pageUrl,
    sectionName,
    dispatch,
    webUrl,
  }) =>
  () => {
    let manualDiscountCode = "";
    // jgunther apply discount code manually through url
    // for (let i = 0; i < lineItems.length; i++) {
    //   if (lineItems[i].title === 'Restore') {
    //     manualDiscountCode = '&discount=MOMS15';
    //   }
    // }

    dispatch(checkout(webUrl + manualDiscountCode));

    trackCheckout({
      subtotal: subtotalPrice,
      pageUrl,
      action: EVENT_PROPERTIES_VALUES.Checkout_Button_Clicked,
      numLineItems: lineItems.length,
      cartItems: getLineItemDetails(lineItems),
      totalQuantity: getTotalQuantity(lineItems),
      lineItems,
      sectionName,
    });
  };

export const CheckoutButton = ({
  trackingProps: { sectionName },
  buttonProps,
  children,
}) => {
  const dispatch = useDispatch();
  const { subtotalPrice, lineItems, webUrl } = useSelector((state) =>
    getCheckoutState(state)
  );
  const btnProps = { ...DEFAULT_BUTTON_PROPS, ...buttonProps };
  const {
    trackingActions: { trackCheckout },
    pageUrl,
  } = useContext(TrackingContext);

  return (
    <Button
      className="checkout_button"
      onClick={openCheckout({
        subtotalPrice,
        lineItems,
        trackCheckout,
        pageUrl,
        sectionName,
        dispatch,
        webUrl,
      })}
      {...btnProps}
    >
      {children}
    </Button>
  );
};

CheckoutButton.propTypes = {
  children: PropTypes.any,
  trackingProps: PropTypes.shape({
    sectionName: PropTypes.string,
  }).isRequired,
  buttonProps: PropTypes.object,
};

CheckoutButton.defaultProps = {
  children: "Checkout",
  buttonProps: DEFAULT_BUTTON_PROPS,
};

export default CheckoutButton;
